import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "title-icon"
};
const _hoisted_2 = {
  class: "text-box"
};
const _hoisted_3 = {
  class: "title-text"
};
const _hoisted_4 = ["id"];
const _hoisted_5 = {
  class: "icon-container",
  id: "automation-icon-container"
};
const _hoisted_6 = {
  style: {
    "padding": "10px 24px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_WrapWithPopover = _resolveComponent("WrapWithPopover");
  const _component_b_tab = _resolveComponent("b-tab");
  const _component_b_tabs = _resolveComponent("b-tabs");
  const _component_pause_in_circle_icon = _resolveComponent("pause-in-circle-icon");
  const _component_play_3d_icon = _resolveComponent("play-3d-icon");
  const _component_b_button = _resolveComponent("b-button");
  const _component_app_modal = _resolveComponent("app-modal");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    class: _normalizeClass(['ppc-settings-tab-container', {
      disabled: $props.disabled
    }])
  }, [_createVNode(_component_b_tabs, {
    style: _normalizeStyle($options.cssProps),
    "content-class": "mt-3",
    justified: "",
    class: "ppc-settings-tabs",
    modelValue: $options.currentTab,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.currentTab = $event)
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tabs, ({
      title,
      subtitle,
      disabled,
      icon
    }) => {
      return _openBlock(), _createBlock(_component_b_tab, {
        disabled: disabled,
        key: title
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_1, [(_openBlock(), _createBlock(_resolveDynamicComponent(icon), {
          class: "icon"
        })), _createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(title), 1)]), _createVNode(_component_WrapWithPopover, {
          target: `tooltip-${title}`
        }, {
          title: _withCtx(() => [_createTextVNode(_toDisplayString(subtitle), 1)]),
          default: _withCtx(() => [_createElementVNode("div", {
            id: `tooltip-${title}`
          }, [_createVNode(_component_app_icon, {
            icon: "info-circle",
            size: 12,
            color: "#757575"
          })], 8, _hoisted_4)]),
          _: 2
        }, 1032, ["target"])])]),
        _: 2
      }, 1032, ["disabled"]);
    }), 128))]),
    _: 1
  }, 8, ["style", "modelValue"]), _createVNode(_component_b_button, {
    onClick: $options.handleClick,
    class: _normalizeClass(['ppc-automation-controller', $props.status])
  }, {
    default: _withCtx(() => [_createVNode(_component_WrapWithPopover, {
      target: "automation-icon-container",
      width: "fit-content"
    }, {
      title: _withCtx(() => [_createTextVNode(_toDisplayString($data.texts[$props.status] ?? "Resume budget strategies"), 1)]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [$options.enabled ? (_openBlock(), _createBlock(_component_pause_in_circle_icon, {
        key: 0,
        color: "#2172E1",
        height: 16,
        width: 16
      })) : (_openBlock(), _createBlock(_component_play_3d_icon, {
        key: 1,
        height: 16,
        width: 16
      }))])]),
      _: 1
    })]),
    _: 1
  }, 8, ["onClick", "class"])], 2), _createVNode(_component_app_modal, {
    modelValue: $data.changeModal,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.changeModal = $event),
    title: "Confirm PPC Automation Status Update",
    "cancel-title": "No",
    "ok-title": "Yes",
    onOk: _cache[2] || (_cache[2] = () => {
      this.enabled ? _ctx.$emit('pause') : _ctx.$emit('enable');
      this.loading = true;
      this.changeModal = false;
    }),
    custom_class: "confirm-block-modal"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createTextVNode(" Are you sure you want to "), _createElementVNode("b", null, _toDisplayString(this.enabled ? "PAUSE" : "ENABLE"), 1), _createTextVNode(" Budget and Bidding Automation on this profile ? ")])]),
    _: 1
  }, 8, ["modelValue"])], 64);
}